export function changeBanksFields(fields, dlocalBanks, country) {
    if (typeof fields.bank_origin === 'undefined' || fields.bank_origin === '') {
        return fields;
    }

    const dlocalBank = dlocalBanks.find(bk => parseFloat(fields.bank_origin) === bk.id);

    if (dlocalBank) {
        return Object.assign({}, fields, {
            bank_destination: dlocalBank.id
        });
    }

    //default banks
    switch (country) {
        case 'AR':
            return Object.assign({}, fields, {
                bank_destination: dlocalBanks.find(bk => bk.id === 2).id
            });
        case 'CO':
            return Object.assign({}, fields, {
                bank_destination: dlocalBanks.find(bk => bk.id === 13).id
            });
        case 'CL':
            return Object.assign({}, fields, {
                bank_destination: dlocalBanks.find(bk => bk.id === 1).id
            });
        case 'MA':
            const dlocalBankCode = window.MA_dlocal_bank[fields.bank_origin]
            return Object.assign({}, fields, {
                bank_destination: dlocalBanks.find(bk => bk.code === dlocalBankCode).id
            });
    }
}